import Progressbar from '../widgets/progressbar/Progressbar';

import './style';

const MonitorSummary = ({
  text = '',
  icon = '',
  desc = '',
  subDesc = '',
  progress = false,
  progressValue = 0,
  onClick = () => { }
}) => {

  return (
    <div className="col-xxl-3 col-lg-6 col-12 cmp-monitor-summary">
      <div className="card flex-fill clickable" onClick={onClick}>
        <div className="card-body">
          <div className="d-flex align-items-center mb-auto">
            <div className="font-count">
              <span>{text}</span>
              <span className="summary-description">{desc}</span>
              <span className="summary-description-sub">{subDesc}</span>
            </div>
            <span className="summary-icon-container">
              <i className={icon}></i>
            </span>
          </div>
          {!progress ? '' : (
            <div className="d-flex my-2">
              <Progressbar value={progressValue} rtl height={5} dynamic />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MonitorSummary;
